<template>
  <div class="bg">
    <div class="banner">
      <img src="/static/images/banner-news.png" >
    </div>
    <div class="width1200">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="card">
        <div class="card-title">{{title}}</div>
        <div>
          <span class="card-date">{{$global.format(dtCreate, 'yyyy-MM-dd')}}</span>
          <span class="card-label">来源：{{type == 1 ? '企业动态' : type === 2 ? '行业动态' : ''}}</span>
        </div>
        <div class="card-content" v-html="content"></div>
        <!-- <div class="card-link">上一篇：<span>{{prev}}</span></div>
        <div class="card-link">下一篇：<span>{{next}}</span></div> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        title: '',
        date: '',
        type: '',
        content: '',
        prev: '暂无',
        next: '成易网运荣获2021年最佳网络货运合作商'
      }
    },
    mounted() {
      this.$global.axios.get(this, '/sywl/news/detail', {
        id: this.$global.getUrlKey('id')
      }, res => {
        console.log(res);
        for (let key in res.data) {
          this[key] = res.data[key];
        }
      })
    }
  }
</script>

<style lang="scss">
  .bg {
    padding-bottom: 68px;
    background-color: #f8f8f8;
  }

  .el-breadcrumb {
    margin: 85px auto 32px;
    font-size: 18px;

    &__inner {
      color: #333;

      &.is-link {
        color: #1875f0;
      }
    }
  }

  .card {
    padding: 100px 100px 62px;
    background-color: #fff;
    text-align: left;

    &-title {
      margin-bottom: 24px;
      font-size: 34px;
      color: #333;
    }

    &-date,
    &-label {
      font-size: 16px;
      color: #999;
    }

    &-content {
      margin: 16px auto 48px;
      padding: 48px 0;
      border: 1px solid #f2f2f2;
      border-left: none;
      border-right: none;
    }

    &-link {
      font-size: 18px;
      color: #333;

      & + & {
        margin-top: 16px;
      }

      span {
        color: #999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/newsDetail.vue


// WEBPACK FOOTER //
// src/pages/newsDetail.vue